type ObjectWithProperty = Record<string, unknown>;

export const hasProperty = (
  object: ObjectWithProperty,
  propertyName: string
) => Object.hasOwn(object, propertyName);
